import { PromptType } from 'common/models/types';

// Ground Truth 관련 타입
export interface GroundTruth {
  id: number;
  patientId: number;
  promptType: PromptType;
  expectedContent: string;
  createdAt: string;
  updatedAt: string;
  createdBy: string;
  deletedAt?: string | null;
}

export interface CreateGroundTruthDto {
  patientId: number;
  promptType: PromptType;
  expectedContent: string;
}

export interface UpdateGroundTruthDto {
  patientId?: number;
  promptType?: PromptType;
  expectedContent?: string;
}

export interface GroundTruthFilters {
  patientId?: number;
  promptType?: PromptType;
  includeDeleted?: boolean;
}

// 실험 관련 타입
export enum TestStatus {
  PENDING = 'PENDING',
  RUNNING = 'RUNNING',
  COMPLETED = 'COMPLETED',
  FAILED = 'FAILED'
}

export interface TestExperiment {
  id?: number;
  name?: string;
  description?: string;
  configuration: TestConfiguration[];
  status?: TestStatus;
  totalCount?: number;
  completedCount?: number;
  failedCount?: number;
  startedAt?: Date;
  completedAt?: Date;
  createdAt?: Date;
  createdBy?: string;
}

export interface TestConfiguration {
  aiReviewRequest: AIReviewRequest;
  patientIds?: number[];
  aiReviewIds?: number[];
  aiReviewEvaluationIds?: number[];
  iterations: number;
}

export interface AIReviewRequest {
  patientId?: number;
  modelType?: string;
  priority?: number;
  promptType?: PromptType;
  promptId?: number;
  prescriptionIds?: number[];
  otcIds?: number[];
  hffIds?: number[];
  medicationOptions?: string[];
  docsOptions?: string[];
  evaluationPromptId?: number;
  evaluationModel?: string;
  evaluationUseGTSnapshot?: boolean;
  admin?: {
    targetProcessingStep?: string;
    rerun?: boolean;
  };
}

export interface CreateExperimentDto {
  name?: string;
  description?: string;
  configuration: TestConfigurationDto[];
}

export interface TestConfigurationDto {
  aiReviewRequest: {
    modelType?: string;
    priority?: number;
    promptType?: PromptType;
    promptId?: number;
    medicationOptions?: string[];
    docsOptions?: string[];
    evaluationPromptId?: number;
    evaluationModel?: string;
    evaluationUseGTSnapshot?: boolean;
  };
  patientIds?: number[];
  aiReviewIds?: number[];
  aiReviewEvaluationIds?: number[];
  iterations: number;
}

// 평가 관련 타입
export interface AIReviewEvaluation {
  id: number;
  aiReviewId: number;
  groundTruthId: number;
  score?: number;
  evaluationGroupId?: number;
  experimentId?: number;
  evaluationComments?: string;
  evaluationPromptId?: number;
  evaluationModel?: string;
  groundTruthSnapshot?: string;
  errorMessage?: string;
  evaluatedAt?: string;
  createdAt: string;
  updatedAt: string;
}

export interface AIReviewEvaluationGroup {
  id: number;
  testGroupKey: string;
  evaluationGroupKey: string;
  averageScore: number;
  count: number;
  scrapped?: boolean;
  hidden?: boolean;
  createdAt: string;
  updatedAt: string;
}